module.exports = __webpack_public_path__ + "static/BHS-line-logo-small-c7752f30f573c428d647333a4e78ebdd.png";